import { createImageIconComponent } from './library'

export const IconHelp = createImageIconComponent(
  <svg
    height="40"
    viewBox="0 0 40 40"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: '1.21em', height: '1.22em' }}
  >
    <path
      d="m20 40c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20zm-8.339-6.187 4.308-4.307a10.35 10.35 0 0 0 8.062 0l4.308 4.307c-5.099 3.09-11.58 3.09-16.678 0zm14.79-13.813a6.459 6.459 0 0 1 -6.451 6.452 6.459 6.459 0 0 1 -6.452-6.452 6.459 6.459 0 0 1 6.452-6.452 6.459 6.459 0 0 1 6.452 6.452zm7.362 8.339-4.307-4.308a10.35 10.35 0 0 0 0-8.062l4.307-4.308c3.09 5.099 3.09 11.58 0 16.678zm-5.475-22.152-4.307 4.307a10.35 10.35 0 0 0 -8.062 0l-4.309-4.307c5.099-3.09 11.58-3.09 16.677 0zm-22.15 5.474 4.306 4.308a10.35 10.35 0 0 0 0 8.062l-4.307 4.309c-3.09-5.099-3.09-11.58 0-16.678z"
      fill="currentColor"
    ></path>
  </svg>
)
